/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  cascading: {
    type: String,
    "default": "right-up",
    validator: function validator(val) {
      if (!val) return true;
      return ["left-up", "right-up"].includes(val);
    }
  },
  collapseAvatar: {
    type: [String, Function]
  },
  max: {
    type: Number
  },
  popupProps: {
    type: Object
  },
  size: {
    type: String,
    "default": ""
  }
};

export { props as default };
//# sourceMappingURL=avatar-group-props.mjs.map
